// @flow
import styled from 'styled-components';
import { Button } from '@finect/tabular-core/Button';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

export const ServiceInner = styled.div`
  justify-content: space-between;
  border: 1px solid ${({ theme }) => theme.colors.terciaryL};
  border-radius: ${({ theme }) => theme.borderRadius};
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.shadows.lightBlack};
  margin: 0 5px 15px;
  background-color: ${({ theme }) => `${theme.cardsBackgroundColor}`};
  font-size: 14px;

  :hover {
    box-shadow: ${({ theme }) => theme.shadows.extraBlack};
  }
`;

export const ServiceDetail = styled.div`
  padding: 0 10px;
  border-top: 1px solid ${({ theme }) => theme.colors.terciaryL};

  ${minMediaQueries.phablet`
    padding: 0;
    display: grid;
    grid-column-gap: 10px;
    grid-template-columns: auto auto;
  `};
`;

export const ServiceDetailItem = styled.div`
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.terciaryL};
  margin: 0;
  text-align: center;

  &:last-of-type {
    border-style: none;
  }

  ${minMediaQueries.phablet`
    border-bottom: none;
    padding: 0 10px;
    margin: 15px 0;
    border-right: 1px solid ${({ theme }) => theme.colors.terciaryL};
    &:nth-child(3n+2) {
      border-style:none;
    }
  `};
`;

export const Unsold = styled.div`
  align-items: center;
  width: 100%;
  margin: 15px 0;
  color: ${({ theme }) => theme.colors.terciaryD};
  text-align: left;
  ${getFont('-1')}

  p {
    margin-bottom: 15px;
  }

  ${minMediaQueries.phablet`
    flex-basis: 50%;
    flex-shrink: 1;
    padding: 0 12px;
    border-bottom: none;
    border-right: 1px solid ${({ theme }) => theme.colors.terciaryL};

    &:last-of-type{
      border-style:none;
    }
  `};

  ${minMediaQueries.miniDesktop`
    flex-basis:calc((100% / 2) - 20px);
  `};
`;

export const PendingMessage = styled.div`
  display: flex;
  align-items: center;
  flex: auto;
  justify-content: center;
  margin: 20px auto;
  ${getFont('-1')}
  color: ${({ theme }) => theme.colors.terciaryD};

  p {
    width: 100%;
    text-align: center;
  }

  ${minMediaQueries.phone`
    p {
      width: 300px;
    }
  `};

  ${minMediaQueries.desktop`
    p {
      width: 100%;
    }
  `};
`;

export const IconContent = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;

export const ModalTitle = styled.div`
  margin: 15px auto 5px;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
`;

export const ActionsInner = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0;

  ${minMediaQueries.phone`
    margin: 24px 48px 43px 0;
    justify-content: flex-end;
  `};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 270px;
`;

export const ButtonBlock = styled.div`
  margin: 10px auto;
  text-align: center;
`;

export const ButtonRefuse = styled(Button)`
  background-color: ${({ theme }) => theme.colors.secondaryD};
`;

export const MenuActionsMobile = styled.div`
  display: block;
  padding: 8px 16px 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.terciaryL};

  ${minMediaQueries.phone`
    display: none;
  `};
`;

export const OrganizationWithCTA = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 15px;

  ${minMediaQueries.phablet`
    flex-basis:calc(50% - 20px);
  `};

  ${minMediaQueries.miniDesktop`
    flex-direction: row;
    flex-basis:calc((200% / 3) - 20px);
  `};

  > div {
    border-style: none;
  }
`;
